interface BrowserSupport {
  [key: string]: string | null;
}

export const browserSupportForHasSelector: BrowserSupport = {
  IE: null, // Not supported
  "Samsung Internet": null,
  "Android Browser": null, // Not supported
  Chrome: "105",
  Firefox: "121",
  Safari: "16",
  Edge: "105",
  Opera: "91",
};

function detectBrowser(userAgent: string): { name: string; version: string } {
  const regexes = {
    Chrome: /Chrome\/(\d+)/,
    Firefox: /Firefox\/(\d+)/,
    Safari: /Version\/(\d+)..*Safari\//,
    Edge: /Edg\/(\d+)/,
    Opera: /OPR\/(\d+)/,
    "Samsung Internet": /SamsungBrowser\/(\d+)/,
    "Android Browser": /Android.*Version\/(\d+)/,
  } as Record<string, RegExp>;

  return (
    Object.keys(regexes)
      .map((key) => {
        const match = userAgent.match(regexes[key]);
        if (match) {
          return { name: key, version: match[1] };
        }
        return null;
      })
      .find((result) => result !== null) || { name: "Unknown", version: "0" }
  );
}

function hasHasSelectorSupport(userAgentString: string): {
  browser: string;
  actualVersion: string;
  minimumVersion: string;
  isSupported: boolean;
} {
  const { name, version } = detectBrowser(userAgentString);
  const supportedVersion = browserSupportForHasSelector[name];

  let isSupported = false;

  if (supportedVersion === null) {
    isSupported = false;
  }

  if (supportedVersion && Number.parseInt(version) >= Number.parseInt(supportedVersion)) {
    isSupported = true;
  }

  return {
    browser: name,
    actualVersion: version,
    isSupported,
    minimumVersion: supportedVersion || "",
  };
}

export const { browser, actualVersion, minimumVersion, isSupported } = hasHasSelectorSupport(
  navigator.userAgent
);
console.debug(`Browser: ${browser} - Version: ${actualVersion} - Supported: ${isSupported}`);
